import React, { Component } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import UsersApi from '../../api/users';
import EmployersApi from '../../api/employers';
import { showError, showMessage } from '../../actions/uiActions';
import LineProgress from '@mui/material/LinearProgress'
import { connect } from 'react-redux';
class ResetUserPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      generate: true,
      busy: false
    }
  }

  submit = async () => {
    if (!this.state.generate && this.state.password.length < 8) {
      this.props.showError("The new Account Password must have at least 12 characters.")
      return;
    }
    else {
      this.setState({ busy: true });
      try {
        if (this.props.userType === "employer_admin") {
          await EmployersApi.employerAdminReset(this.props.id, !this.state.generate ? this.state.password : "");
        } else {
          await UsersApi.reset(this.props.id, !this.state.generate ? this.state.password : "");
        }
        this.props.showMessage("An email has been sent to the user with the new Account Credentials.");
        this.props.onClose();
      } catch (error) {
        this.setState({ busy: false });
        this.props.showError(error);
      }
    }
  }
  render() {
    return <Dialog
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description" open={true}
    >
      <DialogTitle id="alert-dialog-title">Reset User Password</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          You are going to reset the Account Password for the User. Use the form below to indicate whether you want the new User Account Password to be generated automatically or not.

        </DialogContentText>
        <div className="line-break"></div>
        <div className="text-center">
          {!this.state.generate && <input disabled={this.state.busy} style={{ display: "inline-block", width: "60%" }} autoComplete="new-password" type="text" name="newPassword" onChange={e => this.setState({ password: e.target.value })} className="form-control" value={this.state.password} placeholder="New Account Password" />}
          <FormControlLabel
            control={
              <Switch disabled={this.state.busy} checked={this.state.generate} onChange={() => this.setState({ generate: !this.state.generate })} value="generate" />
            }
            label="Generate New Account Password Automatically"
          />
        </div>
      </DialogContent>
      <DialogActions>
        {!this.state.busy && [<Button variant="outlined" onClick={this.submit} color="primary" autoFocus>
          Reset Account Password
        </Button>,
        <Button onClick={this.props.onClose} color="primary">
          Cancel
        </Button>]}
        {this.state.busy && <LineProgress variant="indeterminate" />}
      </DialogActions>
    </Dialog>
  }
}
export default connect(null, { showError, showMessage })(ResetUserPassword);